import request from '@/utils/request'

let PurchaseApi = {
     getList(data){
        return request._post('/shop/plus.supply.CgOrder/getList', data);
      },
        add(data){
        return request._post('/shop/plus.supply.CgOrder/add', data);
      },
        edit(data){
        return request._post('/shop/plus.supply.CgOrder/edit', data);
      },
         delete(data){
        return request._post('/shop/plus.supply.CgOrder/delete', data);
      },
         changStatus(data){
        return request._post('/shop/plus.supply.NoCgOrdertice/status', data);
      },
}



export default PurchaseApi;


// WEBPACK FOOTER //
// ./src/api/purchase.js